var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagOrkneyIslands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4488 20.1846C31.8075 18.8537 32 17.4548 32 16.0107C32 14.5665 31.8075 13.1676 31.4488 11.8367L14.6087 0.0715332C11.4824 0.340908 8.61344 1.50903 6.26088 3.3166L0.551188 11.8367C0.1925 13.1676 0 14.5665 0 16.0107C0 17.4464 0.190188 18.8376 0.544875 20.1615L6.26081 28.7047C8.61337 30.5123 11.4823 31.6805 14.6086 31.9498L31.4488 20.1846Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.550781 20.1846C1.47653 23.6195 3.51691 26.5966 6.26047 28.7047V20.1846H0.550781Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6083 31.9498C15.0669 31.9893 15.5307 32.0106 15.9996 32.0106C23.392 32.0106 29.6124 26.9968 31.4484 20.1846H14.6083V31.9498Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4484 11.8368C29.6124 5.02455 23.392 0.0107422 15.9996 0.0107422C15.5307 0.0107422 15.0669 0.0321172 14.6083 0.0716172V11.8368H31.4484Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26047 3.31665C3.51691 5.42478 1.47653 8.40184 0.550781 11.8368H6.26047V3.31665Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8646 13.9239H12.5218H12.5218V0.391113C11.0431 0.718988 9.64131 1.25043 8.34781 1.95624V13.9238H0.135438C0.0465 14.607 0 15.3035 0 16.0108C0 16.7181 0.0465 17.4146 0.135438 18.0977H8.34775H8.34781V30.0653C9.64131 30.7711 11.0431 31.3026 12.5218 31.6304V18.0979V18.0978H31.8646C31.9535 17.4146 32 16.7181 32 16.0108C32 15.3035 31.9535 14.607 31.8646 13.9239Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOrkneyIslands);
export default __webpack_public_path__ + "static/media/flag_orkney_islands.42309854a91332bf0ff6f64aa34fd27a.svg";
export { ForwardRef as ReactComponent };